import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { useEffect } from "react";
import { ChatSessionsRail } from "@/features/chat/components/chat-sessions-rail";
import { enterFullPageChat, exitFullPageChat } from "@/features/chat/stores/full-page-chat-panel";

export const Route = createFileRoute("/chat/_layout")({
  component: ChatLayoutRoute,
});

/**
 * MIN-241: pathless layout wrapping `/chat` (MIN-240's composer) and
 * `/chat/$threadId` (MIN-239's conversation) with the persistent sessions
 * rail. `$threadId` comes through as the validated (opaque, MIN-297) `ThreadId`
 * string on the conversation route and is absent on the bare composer —
 * `null` there marks no row active.
 */
function ChatLayoutRoute() {
  const params = useParams({ strict: false });
  const activeThreadId = typeof params.threadId === "string" ? params.threadId : null;

  // The layout is the whole `/chat` subtree's single mount, so it — not the
  // leaves — owns collapsing the gutter panel and suppressing the agent
  // surface. Owning it here means composer↔conversation navigation no longer
  // unmounts and remounts the pairing, which used to flash the panel open for
  // a frame on the way through.
  useEffect(() => {
    enterFullPageChat();
    return () => exitFullPageChat();
  }, []);

  return (
    <div className="flex h-full w-full">
      <ChatSessionsRail activeThreadId={activeThreadId} />
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
